import * as React from "react"

function ToolsIcon(props) {
    return (
        <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M19.574 15.457L15 10.883a2.9 2.9 0 00-3.336-.543L7.5 6.176V3.75L2.5 0 0 2.5l3.75 5h2.426l4.164 4.164A2.907 2.907 0 0010.883 15l4.574 4.574c.57.57 1.492.57 2.059 0l2.058-2.058a1.46 1.46 0 000-2.059zm-6.617-6.668A4.11 4.11 0 0115.883 10l.758.758a5.528 5.528 0 001.71-1.153 5.618 5.618 0 001.481-5.34.468.468 0 00-.785-.214L16.14 6.957l-2.653-.441-.441-2.653L15.953.957a.472.472 0 00-.223-.789 5.627 5.627 0 00-5.335 1.48C9.28 2.762 8.758 4.23 8.785 5.695l3.207 3.207c.317-.074.645-.113.965-.113zm-4.059 3.203L6.684 9.777.73 15.734a2.499 2.499 0 103.536 3.536l4.828-4.829c-.297-.777-.387-1.625-.196-2.449zM2.5 18.437a.94.94 0 01-.938-.937c0-.52.418-.938.938-.938s.938.418.938.938a.938.938 0 01-.938.938z"
                fill={props.fill}
            />
        </svg>
    )
}

export default ToolsIcon
